export const activateAccessForm = [
    {
        cols: [
            {
                formGroup: 'dniForm',
                class: 'col-lg-8 col-10',
                title: 'INTRODUCIR DNI',
                titleClass: 'form-title text-center'
            }
        ]
    },
    {
        cols: [
            {
                class: 'col-lg-6 col-10',
                subtitle: 'Para activar el acceso al Área de Clientes tenemos que verificar tu identidad. Para ello enviaremos un código de seguridad al teléfono móvil que nos facilitaste. Comienza introduciendo tu documento de identidad a continuación.',
                subtitleClass: 'form-subtitle text-center'
            }
        ]
    },
    {
        cols: [
            {
                class: 'col-lg-6 col-10',
                item: 'input',
                type: 'text',
                placeholder: 'DNI',
                inputClass: 'text-input',
                formControlName: 'dni'
            }
        ]
    },
    {
        cols: [
            {
                class: 'col-lg-6 col-10',
                item: 'recaptcha',
                formControlName: 'recaptcha',
                inputClass: 'recaptcha'
            }
        ]
    },
    {
        cols: [
            {
                class: 'col-2',
                item: 'button',
                type: 'regular',
                submit: 'false',
                placeholder: 'Volver',
                inputClass: 'form-button mt-3 btn btn-primary',
                buttonAction: 'navigateToHome'
            },
            {
                class: 'col-4',
                item: 'button',
                type: 'regular',
                submit: 'true',
                placeholder: 'Enviar',
                inputClass: 'form-button mt-3 btn btn-primary',
                buttonAction: 'onSubmit'
            }
        ]
    }
];

